/**
 * @module constants
 */

import localize from "../util/localizeUtils";

export default {
  image: localize("imageText"),
  movie: localize("movieText")
};



// WEBPACK FOOTER //
// ./app/constants/publishingAssetTypes.js